export default {
  title: 'Partenaires',
  search_placeholder: 'Rechercher un partenaire...',
  buttons: {
    default_price_list: 'Liste de prix par défaut',
    create_partner: 'Créer un partenaire',
  },
  columns: {
    name: 'Nom',
    restaurants: 'Restaurants',
    shop_domain: 'Domaine de boutique',
    status: 'Statut',
    earning_enabled: 'Gains activés',
  },
  statuses: {
    invited: 'Invité',
    active: 'Actif',
    suspended: 'Suspendu',
  },
  actions: {
    edit: 'Modifier',
    view_billing: 'Voir la facturation',
    view_as_partner: 'Voir en tant que partenaire',
    suspend: 'Suspendre',
    unsuspend: 'Réactiver',
  },
  suspension: {
    suspend_title: 'Suspendre ce partenaire ?',
    suspend_description:
      "Tous les membres de l'équipe du partenaire seront désactivés et leurs sessions révoquées. Leurs restaurants restent actifs.",
    unsuspend_title: 'Réactiver ce partenaire ?',
    unsuspend_description: "Tous les membres de l'équipe du partenaire seront réactivés et pourront se reconnecter.",
  },
  toasts: {
    load_error: 'Impossible de charger les partenaires.',
    suspended: 'Le partenaire a été suspendu.',
    unsuspended: 'Le partenaire a été réactivé.',
    suspension_error: 'Impossible de modifier le statut du partenaire.',
    view_as_error: "Impossible d'ouvrir le tableau de bord du partenaire.",
  },
};
